const INITIAL_STATE = {
  list: [],
  detail: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_SEMAPHORE":
      return { ...state, list: action.payload };
    case "GET_SEMAPHORE_DETAIL":
      return { ...state, detail: action.payload };
    default:
      return state;
  }
};
